import { type UserDto } from "@pasta/front-auth-v2";

export enum MassSignatureStatus {
  PROCESSING = "PROCESSING",
  DONE = "DONE",
  ERROR = "ERROR",
}

export interface ReadMassSignatureDocumentDto {
  id: number;
  name: string;
  extension: string;
  status: MassSignatureStatus;
  signaturePositionsCount: number;
}

export interface ReadMassSignatureLetterFileDto {
  id: number;
  name: string;
  status: MassSignatureStatus;
  chronoNumber: string;
  documents: ReadMassSignatureDocumentDto[];
  willBeArchived: boolean;
}

export interface ReadMassSignatureDto {
  id: number;
  creationDate: Date;
  modificationDate: Date;
  owner: UserDto;
  letterFiles: ReadMassSignatureLetterFileDto[];
  status: MassSignatureStatus;
}
